import "./Loader.scss";
import logoLg from "../../assets/images/coin45.png";
import PropTypes from 'prop-types';

const Loader = ({ loaded }) => {

   return (
     
      <div>
         <div className="loadermain">
            <div>
               <img alt="logo" src={logoLg} className="img-fluid load" />

            </div>
          
         </div>

      </div>
   )
}
Loader.propTypes = {
   loaded: PropTypes.any
}
export default Loader;